export default __webpack_public_path__ + "static/media/IMG_2004.d572e72f.JPG";